import { render, staticRenderFns } from "./sixLatestActivity.vue?vue&type=template&id=183384e0&scoped=true&"
import script from "./sixLatestActivity.vue?vue&type=script&lang=js&"
export * from "./sixLatestActivity.vue?vue&type=script&lang=js&"
import style0 from "./sixLatestActivity.vue?vue&type=style&index=0&id=183384e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183384e0",
  null
  
)

export default component.exports